module.exports = __webpack_public_path__ + "static/img/solutionDetailPic16.94d283a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic16.jpg
// module id = Hb51
// module chunks = 1